import {UmpireGroup} from '../umpire-group';
import {UmpireMatch} from '../umpire-match';

export interface UmpireRound {
  type: 'round';

  id: string;

  name: string;

  matches: UmpireMatch[];

  group: UmpireGroup;

  slug: string | null;
  start_date: string;
}
